import { useState, useEffect, useRef } from 'react'

export default function useTokenInput({
  size,
  onCompleteToken,
  onChange,
  onChangeTimer,
  timer,
}) {
  const rootElementRef = useRef(null)
  const [tokenMap, setTokenMap] = useState(_getDefaultTokens())
  const [timerTime, setTimerTime] = useState(timer)

  useEffect(_handleValueEvents, [tokenMap])
  useEffect(_handleStartTimer, [])
  useEffect(_handleTimerUpdate, [timerTime])

  function _handleValueEvents() {
    const tokenValueArray =
      Object.keys(tokenMap).map((key) => tokenMap[key]) || []
    const stringFied = tokenValueArray.join('')
    const isTokenValid = stringFied.length === size
    if (!!onChange) onChange(stringFied)

    if (!!isTokenValid && !!onCompleteToken) {
      onCompleteToken(stringFied)
    }
  }

  function _handleStartTimer() {
    let interval
    if (!!timer && typeof timer === 'number') {
      interval = setInterval(() => {
        setTimerTime((currentTime) => {
          const reachedTheLimit = currentTime === 0
          
          if (!reachedTheLimit) {
            return currentTime - 1
          } 
          
          clearInterval(interval)
        })
      }, 1000)
    }
    return () => !!interval && clearInterval(interval)
  }

  function _handleTimerUpdate() {
    if (!!onChangeTimer) onChangeTimer(timerTime)

    if (timerTime === 0) {
      setTokenMap(_getDefaultTokens())
      _resetFocus()
    }
  }

  function _getDefaultTokens() {
    return [...Array(size)].reduce((acc, _, i) => ({ ...acc, [i]: '' }), {})
  }

  function _goToNextInput(i) {
    const nextItem = rootElementRef.current.querySelector(
      `[data-token-i='${i + 1}']`
    )
    if (!!nextItem) nextItem.focus()
  }

  function _resetFocus() {
    const firstItem = rootElementRef.current.querySelector(`[data-token-i='0']`)
    firstItem.focus()
  }

  function onKeyUpHandler(e, i) {
    const hasBackspacePressed = e.which === 8 || e.key === 'Backspace'
    if (hasBackspacePressed) {
      const previousItem = rootElementRef.current.querySelector(
        `[data-token-i='${i - 1}']`
      )
      if (!!previousItem) previousItem.focus()
    }
  }

  function onChangeNumber(e, itemIndex) {
    const value = e?.target?.value
    const isNumberValid = inputedValueIsValid(value)
    const isEmpty = value === ''

    if (isNumberValid) {
      setTokenMap({ ...tokenMap, [itemIndex]: value })
      if (!isEmpty) _goToNextInput(itemIndex)
    }
  }

  return {
    onKeyUpHandler,
    onChangeNumber,
    tokenMap,
    rootElementRef,
  }
}

function inputedValueIsValid(value) {
  const numberValue = Number(value)
  const isNaN = Number.isNaN(numberValue)
  return !isNaN && numberValue >= 0 && numberValue <= 9
}
